import { createReducer, on } from '@ngrx/store';
import { initialState } from './state';
import { AUTOMATION_RFP } from './actions';
import { IMPORT_STATS_TABLE } from 'cargo-chief-commons';

export const reducers = createReducer(
	initialState,
	on(AUTOMATION_RFP.RFP_LIST.GET, (state) => ({ ...state, loading: true })),
	on(AUTOMATION_RFP.RFP_LIST.SUCCESS, (state, action) => ({
		...state,
		loading: false,
		rfpsList: IMPORT_STATS_TABLE(action.content, state.activeUsersList),
		total: action.totalElements,
	})),
	on(AUTOMATION_RFP.RFP_LIST.FAILURE, (state, action) => ({
		...state,
		loading: false,
	})),
	on(AUTOMATION_RFP.USERS_LIST.SET, (state, action) => ({
		...state,
		activeUsersList: action.usersList,
	})),
	on(AUTOMATION_RFP.IMPORT_STAT.UPDATE, (state, action) => ({
		...state,
		rfpsList: state.rfpsList.map((importStatsTable) => {
			const { importStat } = action;
			if (importStatsTable.id == action.importStat.id) {
				return IMPORT_STATS_TABLE([importStat], state.activeUsersList)[0];
			}
			return importStatsTable;
		}),
	})),
	on(AUTOMATION_RFP.IMPORT_STAT.ADD, (state, action) => ({
		...state,
		rfpsList: [
			...IMPORT_STATS_TABLE([action.importStat], state.activeUsersList),
			...state.rfpsList.filter((rfp) => rfp.filename != action.importStat.filename),
		],
	}))
);
